<template>
    <div class="bax-main-wrapper">
        <header>
            <div class="container">
                <div class="d-flex">
                    <div class="bax-logo">
                        <h1>
                            <router-link to="/">
                                <img src="@/assets/images/logo.png" alt="Baxter Compounding">
                            </router-link>
                        </h1>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="bax-login-section">
                <div class="container">
                    <div class="bax-form-wrapper">
                        <div class="bax-section-title">
                            <h1 class="d-flex align-items-center"><img src="@/assets/images/login-img.png" alt="Forgot Password">Forgot Password</h1>
                            <p>We will send you a link to reset your password.</p>
                        </div>

                        <div v-if="!submitted && errorMessage !== ''" class="submitted-message error-message">
                            {{ errorMessage }}
                        </div>

                        <form novalidate @submit.prevent="submit"  v-if="!submitted">
                            <ul>
                                <li>
                                    <div
                                        class="bax-form-element"
                                        v-bind:class="{ 'bax-form-error' : $v.email.$error }"
                                    >
                                        <label for="username">Email Address</label>
                                        <input type="text" id="username" placeholder="" v-model="email">

                                    </div>
                                </li>
                            </ul>
                            <div class="bax-cta-block d-flex align-items-center">
                                <input type="submit" value="Send" class="bax-btn bax-btn-blue">
                            </div>
                        </form>

                        <div v-if="submitted && successMessage !== ''" class="submitted-message success-message">
                            {{ successMessage }}
                        </div>

                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import UserService from '@/core/api/user/user.service';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'ForgotPassword',
    data() {
        return {
            email: '',
            submitted: false,
            successMessage: '',
            errorMessage: '',
        };
    },
    validations: {
        email: {
            required,
        },
    },
    methods: {
        submit() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            UserService.forgotPassword({ mail: this.email })
                .then(() => {
                    this.submitted = true;
                    this.successMessage = 'If you have a valid account then further instructions have been sent to your email address.';
                    this.errorMessage = '';
                })
                .catch((err) => {
                    this.successMessage = '';
                    this.submitted = false;
                    this.errorMessage = err.response.data.message;
                })
                .then(() => {
                    this.$Progress.finish();
                });
        },
    },
};
</script>


<style lang="scss" scoped>
.bax-form-error {
    input {
        border: 1px solid red !important;
    }
}
.login-error {
    color: red;
    font-size: 15px;
}
.error-message {
    color: red;
    font-size: 15px;
}
.submitted-message {
    padding: 10px auto;
}
.success-message {
    color: #86B71B;
}
</style>
